var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('Panel',{attrs:{"name":_vm.widgetData.title}},[_vm._v(" "+_vm._s(_vm.widgetData.title)+" "),_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }